import React from "react";
import "./ToolPrepRemoveBgBlock.css";

/**
 * Shared Remove Background row + short bio for tool prep popups.
 */
const ToolPrepRemoveBgBlock = ({
  active = false,
  onToggle = null,
  disabled = false,
  locked = false,
  bio = "",
  error = null,
  label = "Remove Background",
  /** Drop horizontal padding when nested inside .tool-prep-scroll */
  inScroll = false,
}) => {
  const isOn = locked || active;
  const isDisabled = locked || disabled;

  return (
    <div
      className={`tool-prep-remove-bg${inScroll ? " tool-prep-remove-bg--in-scroll" : ""}`}
    >
      <div className="tool-prep-remove-bg__row">
        <span className="tool-prep-remove-bg__label">{label}</span>
        <button
          type="button"
          className={`tool-prep-remove-bg__toggle${isOn ? " is-on" : ""}`}
          onClick={() => {
            if (!isDisabled && onToggle) onToggle();
          }}
          disabled={isDisabled}
          aria-label={label}
          aria-pressed={isOn}
          title={
            locked
              ? "Background removal is required for this tool"
              : undefined
          }
        >
          <span className="tool-prep-remove-bg__knob" />
        </button>
      </div>
      {bio ? <p className="tool-prep-remove-bg__bio">{bio}</p> : null}
      {error ? <p className="tool-prep-remove-bg__error">{error}</p> : null}
    </div>
  );
};

export default ToolPrepRemoveBgBlock;
